import { call, put } from "redux-saga/effects";
import { socketDisconnectAction } from "../socket/socketDisconnect/action";
import { disconnectSseAction } from "../sse/connectSse/action";
import { clearAllSnackbars } from "../../state/snackbar/snackbarSlice";
import { setSystemSuspending } from "../../state/login/loginSlice";

export function* systemSuspendSaga() {
    try {
        console.log('System suspend cleanup started');

        yield put(setSystemSuspending(true));
        yield put(socketDisconnectAction());
        yield put(disconnectSseAction());
        yield put(clearAllSnackbars())

        console.log('System suspend cleanup completed');
    } catch (error) {
        console.error('System suspend cleanup failed:', error);
    }
}
